import ExecutionContext from '~/Features/ExecutionContext';
import type { OnlineApplicationChoice } from './Model';

export const OnlineApplicationStateStorageKey = 'onlineApplicationState';

export const getStoredOnlineApplicationChoices = (): OnlineApplicationChoice[] => {
    if (ExecutionContext.IsServerSide()) {
        return [];
    }

    const currentStateJson = localStorage.getItem(OnlineApplicationStateStorageKey);

    if (currentStateJson) {
        return JSON.parse(currentStateJson) as OnlineApplicationChoice[];
    }

    return [];
};
